import React from "react";
import { RemoteConfigProvider } from "./RemoteConfigContext";

export const CommonProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return <RemoteConfigProvider>{children}</RemoteConfigProvider>;
};
